<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="Image" height="550" src="images/f0002-01.jpg" width="440"/></p>
<p class="pagebreak">
</p><div class="hidden">A</div>
<p class="contents" id="contents"><a id="page_2"></a><strong>Table of Contents</strong></p>
<p class="toc"><a id="page_3"></a><a class="nounder" href="#/xhtml/ch01#ch01"><strong>Welcome</strong></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch02#ch02"><strong>Growing Up</strong></a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>Leaving The Nest</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong>Gainful Employment</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><strong>Independence</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><strong>Risky Business</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><strong>DDC Merch</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample"><strong>Field Notes</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample"><strong>Rock-n-Roll Efforts</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample"><strong>Logos, Logos, Logos</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample"><strong>The Open Road</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample"><strong>Rescue Efforts</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample"><strong>Multiple Impressions</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample"><strong>Sharing The Mess</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample"><strong>Thick Lines</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch16#ch16" title="Link target outside of Sample"><strong>DDC Factory Floor</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch17#ch17" title="Link target outside of Sample"><strong>Tall Tales World Tour</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch18#ch18" title="Link target outside of Sample"><strong>Dad</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch19#ch19" title="Link target outside of Sample"><strong>Mom</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch20#ch20" title="Link target outside of Sample"><strong>Appreciation</strong></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?061fe428